// src/context/SlottingContext.tsx
import React, { createContext, useContext, useState } from 'react'

export const SlottingContext = createContext<any>(null)

export const SlottingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [messages, setMessages] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [progress, setProgress] = useState<number | null>(null)
  const [taskId, setTaskId] = useState<string | null>(null)

  return (
    <SlottingContext.Provider
      value={{
        messages,
        setMessages,
        isLoading,
        setIsLoading,
        isSending,
        setIsSending,
        progress,
        setProgress,
        taskId,
        setTaskId,
      }}
    >
      {children}
    </SlottingContext.Provider>
  )
}

export const useSlotting = () => useContext(SlottingContext)
